import React from "react";
import { defineMessages } from "react-intl";
import ProfileForm from "../ProfileForm/ProfileForm";
const messages = defineMessages({
    submit: {
        id: "forms.profileCreate.submit",
        defaultMessage: "Create Profile"
    }
});
const ProfileCreateForm = ({ createProfile, ...otherProps }) => (<ProfileForm {...otherProps} onSubmit={createProfile} submitLabel={messages.submit} enhancedStyles={false} isCreate/>);
export default ProfileCreateForm;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileCreateForm/ProfileCreateForm.tsx